import { userMobileVerifyApi } from "src/domain/api/user/userMobileVerifyApi"
import { userSelfGetService } from "./userSelfGetService"

export async function userVerifyService(payload: { mobileNo: string; otp: number }) {
	const { token } = await userMobileVerifyApi(payload)
	const { user, company } = await userSelfGetService(token)
	return { token, user, company }
}
